import { reduxSetter } from '../../../../../utils/reduxSetter';
import { SET_CUSTOMERS_LIST_DATA } from '../../constants';
import { buildState } from '../../../../../common/factories/reduxState';

const initialState = buildState({
    filters: {
        customerPhone: undefined,
        divisionId: undefined,
    },
});

export const CustomersList = (state = initialState, action) => {
    switch (action.type) {
    case SET_CUSTOMERS_LIST_DATA:
        return reduxSetter(state, action);
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/CustomersList/redux/reducers/index.js